import styled from 'styled-components';
import theme from 'themes';

export const ContextMenuContainer = styled.div<{ top: number; left: number }>`
  position: fixed;
  top: ${({ top }) => `${top}px`};
  left: ${({ left }) => `${left-192}px`}; //192 is the min-width of the context menu
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.lightGrey2};
  border-radius: 0.375rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 12rem;
  overflow: hidden;
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 0.875rem;
  color: ${theme.colors.text.lightBlack};

  &:hover {
    background-color: ${theme.colors.lightGrey1};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${theme.colors.lightGrey3};
  }

  svg {
    width: 1rem;
    height: 1rem;
  }
`;

export const MenuOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
`;
